module.exports = __webpack_public_path__ + "img/icon-create-error.1cede75a.png";